var _g, _g2, _path, _path2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiberia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.516 93.092h394.968c-14.588-17.665-31.508-33.33-50.277-46.545h-294.414c-18.769 13.213-35.688 28.879-50.277 46.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0 7.847.373 15.605 1.064 23.273h509.872c.691-7.668 1.064-15.426 1.064-23.273s-.373-15.605-1.064-23.272h-509.872c-.691 7.667-1.064 15.425-1.064 23.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.916 372.363h456.168c7.538-14.746 13.686-30.317 18.276-46.544h-492.72c4.589 16.227 10.739 31.799 18.276 46.544z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.793 465.455h294.413c18.769-13.215 35.689-28.88 50.277-46.545h-394.967c14.589 17.663 31.508 33.33 50.277 46.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.639 186.182h492.722c-4.59-16.228-10.739-31.8-18.277-46.545h-456.168c-7.537 14.745-13.687 30.317-18.277 46.545z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.435 46.545h280.772c-41.64-29.318-92.41-46.545-147.207-46.545-33.391 0-91.925 17.227-133.565 46.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.87 139.637h239.214c-8.513-16.653-18.795-32.252-30.6-46.545h-208.614z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.87 232.728h266.066c-1.44-15.982-4.334-31.546-8.575-46.545h-257.491z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.64 325.819h492.72c4.242-14.998 7.136-30.563 8.576-46.545h-509.872c1.44 15.982 4.334 31.546 8.576 46.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.516 418.908h394.968c11.805-14.295 22.087-29.893 30.6-46.545h-456.168c8.513 16.653 18.795 32.252 30.6 46.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 512c54.797 0 105.567-17.227 147.207-46.545h-294.414c41.64 29.318 92.41 46.545 147.207 46.545z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.639 186.182c-4.242 15-7.135 30.563-8.575 46.545h254.936v-232.727c-117.18 0-215.969 78.732-246.361 186.182z",
    fill: "#0052b4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m152.388 66.783 16.575 51.015h53.646l-43.398 31.532 16.574 51.018-43.397-31.53-43.399 31.53 16.578-51.018-43.398-31.532h53.643z",
    fill: "#f0f0f0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberia);
export default __webpack_public_path__ + "static/media/liberia.3f3347c9e283f017333a5b9ddba87311.svg";
export { ForwardRef as ReactComponent };